'use client';

import { useEffect } from 'react';
import { initializeFullStory } from 'src/lib/fullstory';

const FullStoryInitializer = () => {
	useEffect(() => {
		initializeFullStory();
	}, []);

	return null;
};

export default FullStoryInitializer;
